<template>
  <div class="mx-auto my-2">
    <v-card class="mx-4" flat>
      <v-card-title>
        CPD Activity
        <v-spacer></v-spacer>
        <div class="ml-12">
          <v-btn
              v-if="canCreateProgram"
              class="teal white--text"
              depressed
              @click="addProgram()"
          >
            <v-icon left>mdi-plus-circle</v-icon>
            <span>Add CPD Activity</span>
          </v-btn>
        </div>

      </v-card-title>

      <v-layout class="pb-2 px-4" row wrap>
        <v-flex class="px-2 my-2" lg4 md4 sm2 xl3 xs1>
          <v-autocomplete
              v-model="cpdProviderValue"
              :clearable="clearable"
              :elevation="1"
              :items="CPD_PROVIDERS"
              :loading="cpdProviderLoading"
              :searchable="searchable"
              item-text="trainingCenterName"
              item-value="id"
              label="search cpd provider"
          ></v-autocomplete>
        </v-flex>
        <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
          <v-menu
              ref="menu"
              v-model="startMenu"
              :close-on-content-click="false"
              max-width="290px"
              min-width="290px"
              offset-y
              transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="cpdStartDateValue"
                  :clearable="true"
                  persistent-hint
                  placeholder="Cpd Activity Start Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                ref="date"
                v-model="cpdStartDateValue"
                no-title
                placeholder="Cpd Activity Start Date"
                scrollable
                @input="startMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex class="p-3" lg4 md4 sm2 xl3 xs1>
          <v-menu
              ref="menu"
              v-model="startMenu2"
              :close-on-content-click="false"
              max-width="290px"
              min-width="290px"
              offset-y
              transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="cpdEndDateValue"
                  :clearable="true"
                  persistent-hint
                  placeholder="Cpd Activity End Date"
                  prepend-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                ref="date"
                v-model="cpdEndDateValue"
                no-title
                placeholder="Cpd Activity End Date"
                scrollable
                @input="startMenu2 = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout>

      <v-data-table
          :headers="headers"
          :items="programs.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="programs.count"
          class="elevation-1"
          loading-text="Loading... please wait"
      >
        <template v-slot:[`item.programType.name`]="{ item }">
          <label for="item">{{
              item.programType ? item.programType.name : "-"
            }}</label>
        </template>
        <template v-slot:[`item.category.name`]="{ item }">
          <label for="item">{{
              item.category ? item.category.name : "-"
            }}</label>
        </template>
        <template v-slot:[`item.cpdProvider.trainingCenterName`]="{ item }">
          <label for="item">{{
              item.cpdProvider ? item.cpdProvider.trainingCenterName : "-"
            }}</label>
        </template>
        <template v-slot:[`item.courseTitleCat2`]="{ item }">
          <label for="item">{{
              item.courseTitleCat2 ? item.courseTitleCat2 : (item.program_courses.length !== 0 ? item.program_courses[0].course.courseName : "-")
            }}</label>
        </template>
        <template v-slot:[`item.ceu`]="{ item }">
          <label for="item">{{
              item.ceu ? item.ceu : (item.program_courses.length !== 0 ? item.program_courses[0].course.continualEducationUnit : "-")
            }}</label>
        </template>
        <template v-slot:[`item.facilitatedBy`]="{ item }">
          <label for="item">{{
              item.facilitatedBy ? item.facilitatedBy : "-"
            }}</label>
        </template>
        <template v-slot:[`item.participantsNumber`]="{ item }">
          <label for="item">{{
              item.participantsNumber ? item.participantsNumber : "-"
            }}</label>
        </template>
        <template v-slot:[`item.trainersNumber`]="{ item }">
          <label for="item">{{
              item.trainersNumber ? item.trainersNumber : "-"
            }}</label>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-if="canViewProgram" v-slot:activator="{ on }">
              <v-icon
                  class="mr-2"
                  style="color: teal"
                  @click="viewProgram(item)"
                  v-on="on"
              >mdi-eye
              </v-icon
              >
            </template>
            <span>View CPD Activity</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-if="canEditProgram" v-slot:activator="{ on }">
              <v-icon
                  class="mr-2"
                  style="color: teal"
                  @click="editProgram(item)"
                  v-on="on"
              >mdi-circle-edit-outline
              </v-icon
              >
            </template>
            <span>Edit CPD Activity</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <template>
      <v-dialog v-model="dialog" persistent width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >{{ title }}
            <v-spacer></v-spacer>

            <v-btn color="white" text @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title
          >
          <v-divider></v-divider>
          <HrdAddProgram
              v-if="dialog"
              :changeCategoryNo="changeCategoryNo"
              :changeProgramTypeNo="changeProgramTypeNo"
              :program="program"
              @close="closeDialog()"
              @registerOrUpdateProgram="registerOrUpdateProgram"
          ></HrdAddProgram>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog v-model="detailDialog" persistent width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >
            {{ title }}
            <v-spacer></v-spacer>

            <v-btn color="white" text @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>
          <HrdProgramDetail
              v-if="detailDialog"
              :program="program"
          ></HrdProgramDetail>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>


<script>
import HrdAddProgram from "./hrd-add-program";
import HrdProgramDetail from "./hrd-program-detail";
import {ProgramService} from "./programs.service";
import {getUser} from "@/utils/helper";
import {TrainingCenterService} from "../TrainingCenter/training_center.service";

export default {
  components: {
    HrdAddProgram,
    HrdProgramDetail,
  },

  data() {
    return {
      dialog: false,
      detailDialog: false,
      title: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      search: "",
      programs: [],
      headers: [
        {text: "CPD Activity Type", value: "programType.name"},
        {text: "CPD Activity", value: "category.name"},
        {text: "CPD Activity Provider", value: "cpdProvider.trainingCenterName"},
        {text: "Course Name", value: "courseTitleCat2"},
        {text: "CEU", value: "ceu"},
        {text: "Facilitated By", value: "facilitatedBy"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      loading: false,
      program: null,
      changeProgramTypeNo: null,
      changeCategoryNo: null,
      cpdProviderLoading: false,
      CPD_PROVIDERS: [],
      searchable: true,
      clearable: true,
      cpdProviderValue: null,
      startMenu: false,
      startMenu2: false,
      cpdStartDateValue: null,
      cpdEndDateValue: null
    };
  },
  async beforeMount() {
    this.fetchProgramList();
    this.cpdProviderLoading = true;
    const trainingCenterResp = await TrainingCenterService.getAllTrainingCenters();
    this.CPD_PROVIDERS = trainingCenterResp.data.rows;
    this.cpdProviderLoading = false;
  },
  watch: {
    options: {
      handler() {
        this.fetchProgramList();
      },
      deep: true,
    },
    search: function (val) {
      this.search = val;
      this.fetchProgramList();
    },
    cpdProviderValue: function (val) {
      this.cpdProviderValue = val == null ? null : val;
      this.fetchProgramList();
    },
    cpdStartDateValue: function (val) {
      this.cpdStartDateValue = val == '' ? null : val;
      this.fetchProgramList();
    },
    cpdEndDateValue: function (val) {
      this.cpdEndDateValue = val == '' ? null : val;
      this.fetchProgramList();
    }
  },
  computed: {
    canCreateProgram() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName === "CPD Activity" && permission.canCreate
      );
    },
    canEditProgram() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName === "CPD Activity" && permission.canUpdate
      );
    },
    canViewProgram() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName === "CPD Activity" && permission.canRead
      );
    },
  },
  methods: {
    async fetchProgramList() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      let searchParams = '';
      this.cpdProviderValue !== null && (searchParams += '&trainingCenterId=' + this.cpdProviderValue);
      this.cpdStartDateValue !== null && (searchParams += '&startDate=' + this.cpdStartDateValue);
      this.cpdEndDateValue !== null && (searchParams += '&endDate=' + this.cpdEndDateValue);

      const res = await ProgramService.getProgramsWP(
          page,
          itemsPerPage,
          searchParams
      );
      if (res.status === 200) {
        this.loading = false;
        this.programs = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching CPD Activity, Please try Again!"
        );
      }
    },
    viewProgram(item) {
      this.program = item;
      this.detailDialog = true;
      this.title = "CPD Activity Detail";
    },
    addProgram() {
      this.program = null;
      this.dialog = true;
      this.title = "Add CPD Activity";
    },
    editProgram(item) {
      this.program = item;
      this.dialog = true;
      this.title = "Edit CPD Activity";
      this.changeProgramTypeNo = 0;
      this.changeCategoryNo = 0;
    },
    closeDialog() {
      this.dialog = false;
      this.detailDialog = false;
      this.fetchProgramList();
    },
    async registerOrUpdateProgram(program) {
      let res = null;

      if (program.editMode) {
        res = await ProgramService.update(program.id, program);

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.closeDialog();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to update CPD Activity, please try again");
        }
      } else {
        res = await ProgramService.create(program);
        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.closeDialog();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create CPD Activity, please try again");
        }
      }
    },
  },
};
</script>
<style scoped>
</style>

